import { render, staticRenderFns } from "./AdicionarPaginaRevista.vue?vue&type=template&id=b627b028&scoped=true"
import script from "./AdicionarPaginaRevista.vue?vue&type=script&lang=ts"
export * from "./AdicionarPaginaRevista.vue?vue&type=script&lang=ts"
import style0 from "./AdicionarPaginaRevista.vue?vue&type=style&index=0&id=b627b028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b627b028",
  null
  
)

export default component.exports